<template>
  <div>

    <div class="case-spisi">
      <div class="spisi-left">
        <div class="case-spisi-folders-line posta-folders-line">
          <div :class="['troskovnici-button']" @click="switchTab('naplata')">
            <div>{{$t("billing_page.naplata_tabs.t1")}}</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none">
              <path
                d="M3.54545 3.85135C3.54545 3.5155 3.81001 3.24324 4.13636 3.24324H9.65152C9.97787 3.24324 10.2424 3.5155 10.2424 3.85135C10.2424 4.1872 9.97787 4.45946 9.65152 4.45946H4.13636C3.81001 4.45946 3.54545 4.1872 3.54545 3.85135Z"
                fill="#2A306B" />
              <path
                d="M4.13636 5.67568C3.81001 5.67568 3.54545 5.94793 3.54545 6.28378C3.54545 6.61963 3.81001 6.89189 4.13636 6.89189H8.07576C8.40211 6.89189 8.66667 6.61963 8.66667 6.28378C8.66667 5.94793 8.40211 5.67568 8.07576 5.67568H4.13636Z"
                fill="#2A306B" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.74242 0C1.67554 0 0 1.72431 0 3.85135V11.9595C0 13.6387 1.32279 15 2.95455 15H11.6212C12.3827 15 13 14.3647 13 13.5811V1.41892C13 0.635272 12.3827 0 11.6212 0H3.74242ZM11.8182 8.91892V1.41892C11.8182 1.30697 11.73 1.21622 11.6212 1.21622H3.74242C2.32824 1.21622 1.18182 2.39601 1.18182 3.85135V9.5268C1.67562 9.1451 2.28941 8.91892 2.95455 8.91892H11.8182ZM11.8182 10.1351H2.95455C1.9755 10.1351 1.18182 10.9519 1.18182 11.9595C1.18182 12.967 1.9755 13.7838 2.95455 13.7838H11.6212C11.73 13.7838 11.8182 13.693 11.8182 13.5811V10.1351Z"
                fill="#2A306B" />
            </svg>
          </div>
          <div :class="['izdani-racuni-button', 'active', { 'tab-middle': can_see_hourly_stats }]">
            <div>{{$t("billing_page.naplata_tabs.t2")}}</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.74242 0C1.67554 0 0 1.72431 0 3.85135V11.9595C0 13.6387 1.32279 15 2.95455 15H11.6212C12.3827 15 13 14.3647 13 13.5811V1.41892C13 0.635272 12.3827 0 11.6212 0H3.74242ZM11.8182 8.91892V1.41892C11.8182 1.30697 11.73 1.21622 11.6212 1.21622H3.74242C2.32824 1.21622 1.18182 2.39601 1.18182 3.85135V9.5268C1.67562 9.1451 2.28941 8.91892 2.95455 8.91892H11.8182ZM11.8182 10.1351H2.95455C1.9755 10.1351 1.18182 10.9519 1.18182 11.9595C1.18182 12.967 1.9755 13.7838 2.95455 13.7838H11.6212C11.73 13.7838 11.8182 13.693 11.8182 13.5811V10.1351Z"
                fill="#2A306B" />
              <g clip-path="url(#clip0_706_32)">
                <path
                  d="M7.54927 7.13067C6.92284 7.13067 6.37402 6.70904 6.07594 6.08176H8.04732V5.21245H5.84683C5.84135 5.14213 5.8384 5.07169 5.8384 4.99975C5.8384 4.92848 5.84133 4.85718 5.84683 4.7878H8.04736V3.91832H6.07596C6.37404 3.2911 6.92284 2.8696 7.54929 2.8696C8.14803 2.8696 8.71183 3.27042 9.02057 3.91517L9.80498 3.54025C9.35025 2.58994 8.48598 2 7.54927 2C6.8451 2 6.18785 2.32177 5.69857 2.90683C5.45248 3.20114 5.26446 3.54455 5.14085 3.91832H4.19531V4.78778H4.97517C4.97098 4.85762 4.96882 4.92895 4.96882 4.99973C4.96882 5.07125 4.97098 5.14166 4.97517 5.21243H4.19531V6.08174H5.14085C5.26446 6.45547 5.45248 6.79849 5.69859 7.09254C6.18787 7.67763 6.84512 8 7.54929 8C8.48602 8 9.35025 7.41014 9.80498 6.45985L9.02057 6.08423C8.71181 6.72982 8.14801 7.13067 7.54927 7.13067Z"
                  fill="#2A306B" />
              </g>
              <defs>
                <clipPath id="clip0_706_32">
                  <rect width="6" height="6" fill="white" transform="translate(4 2)" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div v-if="can_see_hourly_stats" :class="['izdani-racuni-button']" @click="switchTab('naplata-analitika')">
            <div>{{$t("billing_page.naplata_tabs.t3")}}</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.74242 0C1.67554 0 0 1.72431 0 3.85135V11.9595C0 13.6387 1.32279 15 2.95455 15H11.6212C12.3827 15 13 14.3647 13 13.5811V1.41892C13 0.635272 12.3827 0 11.6212 0H3.74242ZM11.8182 8.91892V1.41892C11.8182 1.30697 11.73 1.21622 11.6212 1.21622H3.74242C2.32824 1.21622 1.18182 2.39601 1.18182 3.85135V9.5268C1.67562 9.1451 2.28941 8.91892 2.95455 8.91892H11.8182ZM11.8182 10.1351H2.95455C1.9755 10.1351 1.18182 10.9519 1.18182 11.9595C1.18182 12.967 1.9755 13.7838 2.95455 13.7838H11.6212C11.73 13.7838 11.8182 13.693 11.8182 13.5811V10.1351Z"
                fill="#2A306B" />
              <path d="M4.2 7.6V5.4H5.4V7.6H4.2ZM6.3 7.6V3.6H7.5V7.6H6.3ZM8.4 7.6V2.2H9.6V7.6H8.4Z" fill="#2A306B" />
            </svg>
          </div>
        </div>
        <div class="opening-folder">
          <div class="case-spisi">
            <div class="file-switch-wrapp" @click="toggleFileView">
              <button class="file-switch-view">
                <span class="line"></span>
                <span class="line"></span>
                <span class="line"></span>
                <span class="line"></span>
                <span class="sr-only">Toggle
                  menu</span>
              </button>
              {{ getViewTypeText }}
            </div>
            <div class="file-filter" v-if="active_view_type == 0">
              <v-text-field class="naplata-filter" type="text" :label="$t('billing_page.search_title')" v-model="srch_txt"></v-text-field>
            </div>
          </div>

          <div id="tree-menu" style="overflow:hidden;">
            <TreeViewerVue v-if="inherit_data.folder_id != null && active_view_type == 0" :key="treemenu_counter" :no_empty="true"
              permission_starter="case.spis" :duplicatable="false" :group_type="2" :selected_spis="null"
              :folder_id="inherit_data.folder_id" :group_url="inherit_data.group_url" @loaded-docs="getDocs"
              @merge-docs="getMergeDocs" view_name="racuni" :name_filter="srch_txt" >
            </TreeViewerVue>
            <BlockViewer v-if="inherit_data.folder_id != null && active_view_type == 1" :key="treemenu_counter"  :no_empty="true"
              permission_starter="case.spis" :selected_spis="null" :duplicatable="false" :group_type="2"
              :folder_id="inherit_data.folder_id" :group_url="inherit_data.group_url" @loaded-docs="getDocs"
              :all_files_rec="all_files_rec" view_name="racuni" :movable="false"></BlockViewer>
          </div>

        </div>
      </div>
    </div>
    <v-dialog v-model="newFilePop" width="540">
      <v-card>
        <div>
          <div class="
              flex
              w-full
              h-screen
              items-center
              justify-center
              text-center
              drop-document-main-wrapper
            " id="app">
            <div class="p-12 bg-gray-100 border border-gray-300" @dragover="dragover" @dragleave="dragleave"
              @drop="drop">
              <div class="loading-spinner"></div>
              <input type="file" multiple name="fields[assetsFieldHandle][]" id="assetsFieldHandle"
                class="w-px h-px opacity-0 overflow-hidden absolute drag-drop" @change="onChange" ref="file"
                accept=".pdf" />

              <label for="assetsFieldHandle" class="block cursor-pointer drop-document-area">
                <div>
                  <div class="select-file-message-wrapper">
                    <div class="select-file-message">
                      {{ $t('page_2.page_2_5.upload_pop.instruction') }}
                    </div>
                  </div>
                  <div class="button-select-file-wrapper">
                    <div class="button-default button-select-file">
                      {{ $t('page_2.page_2_5.upload_pop.btn_1') }}
                    </div>
                  </div>
                </div>
              </label>
              <div class="opening-folder opening-radni-dokumenti section">
                <div class="inside-radni-dokumenti">
                  <draggable :class="filelist.length > 3 ? 'row-multiple' : 'row'" :sort="false">
                    <div v-for="upFile in filelist" :key="upFile.id">
                      <div :class="[
                        filelist.length > 3
                          ? 'radni-dokument-inside-multiple'
                          : 'radni-dokument-inside',
                        'preneseni-dokument',
                      ]" draggable="true">
                        <div :class="[
                          filelist.length > 3
                            ? 'document-image-wrapper-multiple'
                            : 'document-image-wrapper',
                        ]">
                          <img class="preneseni-dokument-image" :src="returnFileType(upFile.name)" />
                          <div v-show="filelist.length < 4" class="remove-document" @click="deleteFileInSpis(upFile)">
                            <span>X</span>
                          </div>
                        </div>
                        <div class="preneseni-dokument-title">
                          {{ upFile.name }}
                        </div>

                        <div v-show="filelist.length > 3" class="remove-document-multiple"
                          @click="deleteFileInSpis(upFile)">
                          <span>X</span>
                        </div>
                      </div>
                    </div>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-card-actions>
          <div class="button-upload-wrapper">
            <div class="button-default button-create" @click="!is_waiting_on_insert ? addNewUploadFile() : ''">
              <svg v-if="is_waiting_on_insert" class="update-event-spin" viewBox="0 0 50 50">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
              </svg>
              <span v-else>{{ $t('page_2.page_2_5.upload_pop.btn_2') }}</span>
            </div>
          </div>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="snackbar" :timeout="snackTimeout" color="snack-custom-dark-blue" elevation="24">
        {{ snackText }}
        <div v-for="(od, key) in odbacene" :key="key">{{ od.name }}</div>
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            {{$t("repetitive.okay")}}
          </v-btn>
        </template>
      </v-snackbar>
    </v-dialog>
  </div>
</template>

<script>
import share from "@/apiCallers/promise_handler_db/sharepoint";
import auth from "@/services/auth";
import $ from "jquery";
import gsap from "gsap";
import TreeMenu from "@/components/generalComponents/TreeMenu.vue";
import moment from "moment";
import TreeFolders from "@/components/generalComponents/TreeFolders.vue";
import CaseTab from "@/components/caseComponents/CaseTab.vue";
import draggable from "vuedraggable";
import graph from "@/services/graph.js";
import PregledPoste from "@/components/caseComponents/PregledPoste.vue";
import permissioner from "@/services/permissioner.js"
import { getCaseData } from "@/router/case/handler"
import DataLoader from '@/components/generalComponents/DataLoader'
import admin from "@/apiCallers/promise_handler_db/admin.js";
import TreeViewerVue from "../../../../components/generalComponents/FileViewer/TreeViewer.vue";
import BlockViewer from "../../../../components/generalComponents/FileViewer/BlockViewer.vue";




export default {
  components: {
    TreeMenu,
    TreeFolders,
    draggable,
    CaseTab,
    PregledPoste,
    DataLoader,
    TreeViewerVue,
    BlockViewer
  },
  data() {
    const route_name = this.$route.name;
    let chosen_type;
    if (route_name == 'Racuni') {
      chosen_type = 2
    }
    else {
      chosen_type = 0
    }

    return {
      srch_txt: "",
      //moving 
      moving_file: {
        parentReference: {
          id: "",
        },
        name: "",
      },
      inherit_data: {
        folder_id: null,
        group_url: null,
      },
      active_view_type: 0,
      //upload folder start
      newDirectoryName: "",
      newDirectoryParentId: "",
      newFolderPop: false,
      uploadNode: null,
      //upload folder end
      overlay: false,
      overlay_progress: 0,
      popis_preuzimanja_spisa: [],
      newFilePop: false,
      upload_fold_model: false,
      selected_upload_folder: null,
      order_by_tekst: this.$t('page_2.page_2_5.filt_desc'),
      side_spis_view: false,
      selected_spis: {},
      treemenu_counter: 1,
      smjer: true,
      delete_screen: false,
      trigg: true,
      activityFile: null,
      multi_file_list: [],
      tree: {},
      accessToken: "",
      loading: false,
      selectedFolder: null,
      selectedFile: "",
      progress: 0,
      folders: [],
      predmet_info: { broj_predmeta: '' },
      rootSpisi: [],
      filelist: [],

      mapped_case_permission: [],
      snackbar: false,
      snackTimeout: 10000,
      odbacene: [],
      snackText: '',
      //ulazna i izlazna pošta
      input_mail_id: "",
      output_mail_id: "",
      root_racuni_id: "",
      chosen_type: chosen_type,
      is_waiting_on_insert: false,
      active_mail_type: "",

      all_files_rec: null,
      are_files_loaded: false,
      refresher: 1,

      new_file_name: "",


      permission: {
        create: true,
        update: true,
        delete: true,
        read: true
      },
      folder_name: '',
      anim_duration: 0.5,
      overlay_thumbnail: false,
      pic_loading: true,
      snackbar_move: false,
      page_type: route_name,
    };
  },
  async created() {
    this.accessToken = this.$store.state.aToken
    await permissioner.checkUserInfo();
    await admin.getOrganizationInfo().then((resp) => {
      this.inherit_data.group_url = resp.data.racuni_group_url;
      this.inherit_data.folder_id = resp.data.racuni_root_folder;

    })
  },
  computed: {
    can_see_hourly_stats() {
      return permissioner.can_see_hourly_stats();
    },
    getViewTypeText: function () {
      if (this.active_view_type == 0) {
        return this.$t("billing_page.tree_view")
      } else {
        return this.$t("billing_page.block_view")
      }
    }
  },
  watch: {
    "$store.state.spis_overlay_open": {
      handler: function () {
        if (!this.$store.state.spis_overlay_open) {
          this.pic_loading = true;
        }
      }
    }
  },
  methods: {
    toggleFileView: function () {
      if (this.active_view_type == 0) {
        this.active_view_type = 1;
        this.srch_txt = "";
      } else {
        this.active_view_type = 0;
      }
      $(".file-switch-view").toggleClass("is-active")
    },
    getMergeDocs: function (all_files) {
      this.pdf_merge_file_list = all_files;
    },
    getDocs: function (all_files) {
      this.all_files_rec = all_files;
    },

    is_permission_inside(wanted_permission, assistent_check = true) {
      return permissioner.check_case_permsision(wanted_permission)
    },

    async setPostFolder(mail_type) {
      this.active_mail_type = mail_type;
      this.selected_upload_folder = null;
      // await this.resetFileView();
      if ($('#tree-menu').height() > 960) {
        this.anim_duration = 0.4;
      }
      else {
        this.anim_duration = $('#tree-menu').height() * 0.00045;
      }
      gsap.fromTo('#tree-menu', this.anim_duration, { height: 0 }, { height: 'auto', ease: "none" });
    },

    //dodajem klasu na upload wrapper da ga mogu lakše modificirati, jebem te vuetify
    uploadStyling() {
      this.newFilePop = true;
      setTimeout(function () {
        var upl = document.getElementById("main-file-upload");
        $(upl.parentElement.parentElement).addClass(
          "file-upload-dialog-wrapper"
        );
        $(upl.parentElement).addClass("main-file-upload-wrapper");
        $(upl.nextSibling).addClass("spis-megawrapper-parent");
        $('.spis-megawrapper').removeClass('active');
        $('.main-file-upload-wrapper').find('.spis-megawrapper:first').click();
      }, 100);
    },

    //RESET OF DATA VIEW
    async resetFileView() {
      this.are_files_loaded = false;
      this.newFilePop = false;
      this.treemenu_counter++;
      this.tree.nodes = [];
      this.pdf_merge_file_list = [];
      this.treemenu_counter++;
      this.filelist = [];
    },
    // Add some visual fluff to show the user can drop its files
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
        gsap.to(".loading-spinner", 0, { display: "block" });
        gsap.to(".loading-spinner", 0.5, { opacity: 1 });
        gsap.to(".drop-document-area", 0.5, {
          filter: "blur(3px)",
          opacity: 0.7,
        });
      }
    },
    // Clean up after cursor leaves
    dragleave(event) {
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      gsap.to(".loading-spinner", 0.5, { opacity: 0 });
      gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
    },
    //EVENT following dropping the files in area
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      //
      gsap.to(".loading-spinner", 0.5, { opacity: 0 });
      gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
    },
    // Reaction to event drop, that checks and controls all data
    onChange() {
      this.snackbar = false;
      //check all the inserted files and remove all that don't comply with pdf format START
      let tmp_file_list = [...this.$refs.file.files];
      let filt_tmp_file_list = tmp_file_list.filter((file) => file.size < 57671680);
      const num_odbacenih = tmp_file_list.length - filt_tmp_file_list.length;
      if (num_odbacenih != 0) {
        this.snackbar = true;
        this.odbacene = tmp_file_list.filter((file) => file.size >= 57671680);
        this.snackText = this.$t("snackbars.size_limit")
      }
      tmp_file_list = filt_tmp_file_list;

      let pdf_tmp_file_list = tmp_file_list.filter((p) => {
        let tmp_name_list = p.name.split(".");
        return tmp_name_list[tmp_name_list.length - 1].toLowerCase().includes("pdf");
      });
      //check all the inserted files and remove all that don't comply with pdf format END
      const len_dif = tmp_file_list.length - pdf_tmp_file_list.length;
      if (len_dif > 0) {
        this.odbacene = [];
        this.snackbar = true;
        this.snackText = this.$t("snackbars.not_pdf", { length: len_dif });
      }
      tmp_file_list = pdf_tmp_file_list;
      if ([...this.$refs.file.files].length)
        this.filelist = this.filelist.concat(tmp_file_list);
    },

    //CREATE NEW FOLDER WHEN CLICKED ON ANOTHER FOLDER
    handleFolderCreateFromFolder(node) {
      this.newDirectoryName = "";
      this.newFolderPop = true;
      this.newDirectoryParentId = node.id;

      this.uploadNode = null;
    },

    // CREATE FOLDER FUNCTIONS END

    //inside upload form set the folder id
    setUploadFolder(node) {
      this.selected_upload_folder = node.id;
      console.log("New selected upload folder", node);
    },
    async addNewUploadFile() {
      if (this.filelist.length != 0) {
        const formData = new FormData();
        this.filelist.forEach((fl) => {
          console.log(fl);
          formData.append("files", fl);
        });
        if (this.selected_upload_folder == null) {
          switch (this.chosen_type) {
            case 0:
              this.selected_upload_folder = this.input_mail_id;
              break;
            case 1:
              this.selected_upload_folder = this.output_mail_id;
              break;
            default:
              this.selected_upload_folder = this.root_racuni_id;
              break;
          }
        }
        formData.append("token", this.accessToken);
        formData.append("groupId", this.inherit_data.group_url);
        formData.append("sid", this.selected_upload_folder);
        // formData.append("name", esc_filename);
        // appending file
        this.file_upload_text = "Uploading...";
        this.is_waiting_on_insert = true;
        await share
          .addDocumentInSpis(formData)
          .then(() => {
            this.is_waiting_on_insert = false;
            this.file_upload_text = "Upload";
            this.resetFileView();
            document.getElementById("assetsFieldHandle").value = "";

          })
          .catch((err) => {
            this.is_waiting_on_insert = false;
            this.file_upload_text = "Upload";
            document.getElementById("assetsFieldHandle").value = "";

          });
      }
    },
    // DELETE ALL FILES IN SPIS
    deleteFileInSpis(file) {
      this.filelist = this.filelist.filter((f) => f != file);
    },
    // RETURN APPROPRIATE FILE ICON
    returnFileType(file_name) {
      var idx_ext = file_name.split(".").length - 1;
      var extension = file_name.split(".")[idx_ext].toLowerCase();
      var return_val = require("@/assets/img/doc_icon.svg");
      switch (extension) {
        case "docx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "doc":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pdf":
          return_val = require("@/assets/img/pdf_icon.svg");
          break;
        case "csv":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "xls":
          return_val = require("@/assets/img/xls_icon.svg");
          break;

        default:
          return_val = require("@/assets/img/doc_icon.svg");
          break;
      }
      return return_val;
    },
    //SWITCH TO NEW VIEW BY ROUTE
    switchTab(nastavak) {
      this.$router.push("/" + nastavak);
    },
  },
  mounted() {
    document.body.classList.add("posta-page");
    //za hendlanje desnog spis detalji prozorčića
    setTimeout(function () {
      $(window).scroll(function () {
        var brojDokumenata = $(".spis-megawrapper").length;
        var h = document.documentElement,
          b = document.body,
          st = "scrollTop",
          sh = "scrollHeight";
        var percent =
          ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
        if (percent > 20 || window.matchMedia("(min-width: 1199px) and (max-width: 1570px)").matches) {
          gsap.to(".spisi-right", 0.3, { marginTop: "-12rem" });
        }
        if (percent < 20) {
          gsap.to(".spisi-right", 0.3, { marginTop: "5rem" });
        }
      }); //end scroll function
    }, 1700);
  },
  destroyed() {
    document.body.classList.remove("posta-page");
    setTimeout(() => {
      $(window).off();
    }, 1700);
  },
};
</script>

<style>

</style>